module.exports = __webpack_public_path__ + "04b7b68ceb58a30a9a96a1da2fc75360.png";